export default class ButtonEvent extends Event {
	/**
	 * The static CLICKED type is dispatched when the Button is clicked or while focused, the Space or Enter key is pressed.
	 *
	 * Example: addEventListener(ButtonEvent.CLICKED, (event: ButtonEvent) => {});
	 */
	public static CLICKED = 'ButtonEvent.clicked';

	public constructor() {
		super('ButtonEvent.clicked', { bubbles: true });
	}
}
